import { render, staticRenderFns } from "./UserDetailsModal.vue?vue&type=template&id=2fdca853"
import script from "./UserDetailsModal.vue?vue&type=script&lang=js"
export * from "./UserDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports